import { combineReducers } from '@reduxjs/toolkit';
import { peopleConversationsSlice } from './peopleConversationsSlice';
import { lenderConversationsSlice } from './lenderConversationsSlice';
import { clientConversationsSlice } from './clientConversationsSlice';
import { thirdPartyConversationsSlice } from './thirdPartyConversationsSlice';
import { conversationContactsSlice } from './conversationContactsSlice';
import { conversationsSlice } from './conversationsSlice';
import { saveConversationSlice } from './saveConversationSlice';
import { conversationSlice } from './conversationSlice';
import { conversationOrderSlice } from './conversationOrderSlice';

export const conversationReducer = combineReducers({
  peopleConversations: peopleConversationsSlice.reducer,
  lenderConversations: lenderConversationsSlice.reducer,
  clientConversations: clientConversationsSlice.reducer,
  thirdPartyConversations: thirdPartyConversationsSlice.reducer,
  conversationContacts: conversationContactsSlice.reducer,
  conversation: conversationSlice.reducer,
  conversationOrder: conversationOrderSlice.reducer,
  conversations: conversationsSlice.reducer,
  saveConversation: saveConversationSlice.reducer,
});
